const sliceText = (text, charts) => {
	const newStr = text.replace(/<\/?[^>]+(>|$)/g, '');
	const sliceTextRender = newStr.length > charts ? `${newStr.slice(0, charts)}...` : newStr;

	return sliceTextRender;
};

export default sliceText;
